import { createUseStyles } from 'react-jss';

const styles = {
  mainContent: {
    width: '75vw',
    margin: '0 auto',
    maxWidth: '170rem',
    paddingBottom: '5rem',

    '@media(max-width:1120px)': {
      width: '85vw',
    },
  },
  header: {
    marginBottom: '3rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
